module.exports = __webpack_public_path__ + "static/img/applet-erweima.9e4cf945.jpg";